import { writable } from 'svelte/store';
import * as ls from 'local-storage';

let lang = ls.get('lang');

if (lang) lang = lang == "fr" ? "fr" : "en";
else lang = navigator.language.toLowerCase().includes("fr") ? "fr" : "en";

const createStore = () => {

  const { set, subscribe, update } = writable({ lang });

  return {
    subscribe,
    setLang: lang => update(prev => {
      ls.set('lang', lang);
      return ({ ...prev, lang });
    }),
  }
}

const app = createStore();

export default app;